<template>

  <div class=" gap-4">
    <div class="left fixed left-0 top-0 h-auto z-10">
      <a class="" :href="baseUrl">
        <img  :src="'/imgs/aruvaa_logo.png'" alt="" class="px-3 pt-2  img_size" />
      </a>
      <div class="text-left font-bold left-text px-5">
        <h2 class="text-gray-600">A few click away to start your</h2>
        <h2 class="mt-2 text font-bold" style="color: #4bb2b0">
          aruvaa journey
        </h2>
      </div>
      <div class="choose-img">
        <img :src="'/imgs/choose-host.png'" alt="" class="" />
      </div>
    </div>
    <!-- ... -->
    <div class=" right p-4 mr-5" style="border: none; margin-left: 33.3333%;width:auto;">
      <!-- right card -->
      <div class=" my-5 mr-5">
        <!-- progress bar start from here -->
        <progressstep step="1"></progressstep>
        <!-- progress end  -->
        <div class="mt-5 mx-5">
          <!-- left billing -->
          <div class="text-left leading-none">
            <p class="text-sm">Product Name</p>
            <h5 class="font-semibold text-lg">{{ sideProductName }}</h5>
          </div>
          <!-- select host tenant start -->

          <!-- Devex input box start -->
          <div class="my-4">
            <DxForm :label-location="labelLocation" v-model:form-data="formData" :read-only="false"
              @initialized="saveFormInstance" :show-colon-after-label="true" :show-validation-summary="true"
              :customize-item="form_customizeItem">
              <DxGroupItem>
                <DxSimpleItem :editor-options="hostOptions" data-field="sitename"
                  help-text="Set a unique name for your site(use lowercase alphabets)">
                  <DxRequiredRule message="Host Name is required" />
                </DxSimpleItem>
                <DxButtonItem :button-options="buttonOptions" :disabled="isButtonDisabled"
                  horizontal-alignment="left" />
              </DxGroupItem>


            </DxForm>
          </div>
          <!-- Devex end -->

          <div class="existing" v-show="checkItems">
            <h4 class="font-bold my-4">OR</h4>

            <p>Select your existing host</p>

            <!-- card start -->
            <label v-for="(d, b) in this.prodNotDeployedTenant" :key="b" @click="getTenantData(d.id)"
              class="mt-1 no-underline">
              <div
                class="grid grid-cols-2 gap-4 rounded mt-2 bg-white select border-solid border-2 border-light-blue-500 cursor-pointer">
                <div class="px-3 d-flex">
                  <img :src="'/imgs/host2.png'" alt="error" width="" class="-mt-2" />
                  <!-- <span class="px-6 mt-2 -mb-2 no-underline text-gray-800 "> -->
                  <h6 class="font-semibold p-4">{{ d.name }}</h6>
                  <!-- <p class=" text-sm">
                              product_name
                            </p> -->
                  <!-- </span> -->
                </div>
                <div class="flex justify-end items-center px-3">
                  <i class="fas fa-chevron-right text-green-600"></i>
                </div>
              </div>
            </label>
          </div>

          <!-- card end -->
        </div>
      </div>
      <!-- ... -->

      <!--right card end -->
    </div>
    <div></div>
  </div>

</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import Progressstep from "./Components/Progressbar.vue";
import JetNavLink from "@/Jetstream/NavLink.vue";
import DxScrollView from "devextreme-vue/scroll-view";
import JetButton from "@/Jetstream/Button.vue";
// import { DxTextBox, DxButton as DxTextBoxButton } from 'devextreme-vue/text-box';
import DxForm, {
  DxGroupItem,
  DxSimpleItem,
  DxButtonItem,
  DxLabel,
  DxRequiredRule,
} from "devextreme-vue/form";
import { watch } from "less";

export default {
  props: {
    subscriptionProductId: String,
    subscriptionPriceId: String,
    subscriptionPlanId: String,
    accountId: String,
    sideProductName: String,
    sideSubPlanName: String,
    sideSubPrice: String,
    sideAccountName: String,
    frequency: String,
    tenantListDef: {
      type: Array,
      default: [],
    },
    usrRelatedTenant: {
      type: Array,
      default: () => [],
    },

    prodNotDeployedTenant: {
      type: Array,
      default: () => [],
    },
  },

  components: {
    DxScrollView,
    JetButton,
    JetNavLink,
    AppLayout,
    Progressstep,
    // DxTextBox,
    // DxTextBoxButton,
    DxForm,
    DxGroupItem,
    DxSimpleItem,
    DxButtonItem,
    DxLabel,
    DxRequiredRule,
  },
  data() {
    return {
      baseUrl: this.$utils.goToUrl(window.env.baseTenantUrl),
      tenantData: null,
      productData: null,
      title: "Organisations",
      routeDef: "tenant-lists",
      selectedTenantId: null,
      selectedHost: null,
      formInstance: null,
      labelLocation: "top",
      formData: {
      },
      buttonOptions: {
        text: "Create",
        type: "success",
        useSubmitBehavior: true,
        onClick: this.saveRecord,
      },
      sitename: '',
      hostOptions: {
        buttons: [
          {
            name: "",
            location: "after",
            options: {
              text: ".aruvaa.com",
              type: "default",
            },

          },
        ],
      },
    };
  },

  methods: {


    form_customizeItem(item) {
      console.log("item", item);
    },
    resetForm() {
      console.log("input empty resetForm");
      this.formData = {};
    },

    saveRecord() {
      if (this.formData.sitename !== undefined || this.formData.sitename !== '') {
        // console.log(this.formData.sitename,"hello world!");
        this.$inertia.post(route("marketplaces.onboard.organisations", this.formData));
        this.resetForm();
      }

    },

    getTenantData(id) {
      this.selectedTenantId = id;
      var data = {
        subscriptionProductId: this.subscriptionProductId,
        subscriptionPlanId: this.subscriptionPlanId,
        subscriptionPriceId: this.subscriptionPriceId,
        frequency: this.frequency,
        tenantId: this.selectedTenantId,
        sideProductName: this.sideProductName,
        sideSubPlanName: this.sideSubPlanName,
        sideSubPrice: this.sideSubPrice,
      };
      if (this.selectedTenantId != null) {
        // this.$inertia.post(route("marketplaces.billingaccounts"), data);
        this.deleteCookie("aruvaaProductPage");
        // this.$inertia.post(route("tenant-setups.trailsetup"), data);

        this.$inertia.post(route("marketplaces.paymentcomplete"), data);
      } else {
        alert("Please Select Any Host !! ");
      }
    },
    saveFormInstance(e) {
      this.formInstance = e.component;
    },

    goToDashboard(hostname) {
      //  this.$inertia.get(route("dashboard"));
    },
    deleteCookie(name) {
      document.cookie = `${name}=; domain=.aruvaa.net.in; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
    },
    isProxyArrayEmpty(proxyArr) {
      return proxyArr.length === 0;
    }
  },
  computed: {
    checkItems() {
      if (!this.isProxyArrayEmpty(this.prodNotDeployedTenant)) {
        return true;
      }
      return false;
    },
    //  console.log("input empty computed");
  },
  created() {
    console.log("input empty created");
  },

  mounted() {
    // console.log("input empty mounted");

    this.resetForm();
    // this.checkItems();
    // this.$watch('prodNotDeployedTenant', (oldValue, newValue) => {
    //   console.log("watching.prodNotDeployedTenant");
    //   this.checkItems();
    // });

    console.log("product deployed", this.prodNotDeployedTenant.length);
    // this.formData.sitename="";
    // console.log('input empty')
    // console.log("usrRelatedTenant", this.usrRelatedTenant);
    // console.log("prodNotDeployedTenant", this.prodNotDeployedTenant);
  },
};
</script>

<style>
a {
  text-decoration: none !important;
}

.select:hover {
  background: #b8e3cf !important;
}

.left-text {
  margin-top: 130px;
  position: sticky;
}

.img_size {
  height: auto;
  width: 176px;
}

p {
  margin-bottom: 0.1rem;
}

h6,
h3,
h2 {
  margin-bottom: 0.03rem;
}

.left {
  background-color: #eff3f2;
  top: 0;
  left: 0;
  overflow-y: auto;
  width: 33.3333%;
  /* height: 91.5vh; */
}

.right {
  width: 33.3333%;
}

.img {
  width: 35%;
}


.choose-img {
  height: 350px;
  width: 350px;
  margin: 1rem auto;
  text-align: center;
}

.dx-texteditor-input {
  margin: 0;
  padding: 8px 5px;
  color: #333;
  font-size: 1em;
  border-radius: 4px;
  min-height: 24px;
}

.dx-texteditor-input:hover {
  border: 0px solid rgb(2, 214, 161);
}

.dx-button {
  border-radius: 2px 4px;
  border-width: 5px 10px;
  border-style: solid;
}

.dx-texteditor-buttons-container>.dx-button {
  margin: 0px;
}

.dx-field-item-label-location-top {
  display: inline-block;
  margin-bottom: 0.1rem;
}

.dx-button-mode-contained.dx-button-success {
  background-color: #10b981;
  border-color: transparent;
  color: #fff;
}

.dx-button-mode-contained.dx-button-success:hover {
  background-color: #0ca572 !important;
  border-color: transparent;
  color: #fff;
}

.dx-button {
  border-radius: 4px;
  border-width: 4px 12px;
  border-style: solid;
  font-size: medium;
  font-weight: 500;
}


.dx-layout-manager .dx-field-item:not(.dx-first-row) {
  padding-top: 20px;
}

label {
  display: block;
  margin-bottom: 0.5rem;
}

.dx-button-mode-contained.dx-button-default {
  background-color: #10B981 !important;
  border-color: transparent;
  color: #fff;
}

.dx-button-mode-contained.dx-button-default:hover {
  background-color: #0ca572 !important;
  border-color: transparent;
  color: #fff;
}
</style>